<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="card min-height">
      <div class="card-body">
        <div class="px-4 pb-4">
          <div class="row mb-4">
            <div class="col-3">
              <h2 class="card-title-desc">Customer Orders Statements</h2>
            </div>
            <div class="col-4" v-if="httpLoading">
              <b-button variant="primary" size="sm" class="py-2 text-white" :disabled="httpLoading">Loading</b-button>
            </div>
            <div class="col-4" v-else>
              <b-button v-if="orders.objects.length > 0" variant="primary" size="sm" class="py-2 text-white" type="submit" @click="generateStatement(institution.name)">Generate Statements</b-button>
            </div>
          </div>
          <div v-for="(error, index) in httpErrors" :key="index" style="color: #D13704;">
            {{error.message}}
          </div>
          <TableLoading v-if="orders.page === 0"/>
          <div v-else>
            <data-table :columns="columns" :rows="orders.objects" :current-page="currentPage" :has-pagination="false" :has-select="true" @selectFn="selectFn">
              <template v-slot:actions="slotProps">
                <b-button variant="info" size="sm" class="py-1 text-white" @click="viewOrderInvoice(slotProps.row.publicId)">
                  View Invoice
                </b-button>
              </template>
            </data-table>
          </div>

        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config.json";
import Layout from "@/router/layouts/main"
import PageHeader from "@/components/page-header";
import {routeItems} from "@/router/endpoints";
import DataTable from "@/components/data-table";
import {SINGLE_CUSTOMER} from "@/gql";
import {ALL_CUSTOMER_ORDERS_SHORTENED} from "@/gql/orders";
import TableLoading from "@/components/TableLoading";
import {mapActions, mapGetters} from "vuex";
import {downloadFileConfig} from "@/filters/downloadFileConfig";
import {errorToast} from "@/components/successToast";

export default {
  page: {
    title: "Customer Orders",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {TableLoading, DataTable, PageHeader, Layout},
  name: "single-customer-orders",
  data() {
    return {
      title: "Customer Orders",
      items: [
        {
          text: "Orders",
          href: routeItems.customer_orders_route
        },
        {
          text: "Customer Orders",
          active: true
        }
      ],
      orders: {
        page: 0,
        objects:[]
      },
      institution: {},
      branchIds: [],
      selectedOrders: [],
      currentPage: 0,
      perPage: 30,
      searchTerm: "",
      searchKeyword: "",
      paymentStatus: [20, 40],
      columns: [
        {
          field: 'invoiceId',
          label: 'Invoice'
        },
        {
          field: 'salesCustomer',
          label: 'Customer'
        },
        {
          field: 'deliveryDate',
          label: 'Delivery Date'
        },
        {
          field: 'paymentDueDate',
          label: 'Payment Due Date'
        },
        {
          field: 'statementGenDate',
          label: 'Status'
        },
        {
          field: 'actions',
          label: "Actions"
        }
      ],
    }
  },
  apollo: {
    institution: {
      query: SINGLE_CUSTOMER,
      variables() {
        return {
          id: this.$route.params.id,
        }
      }
    },
    orders: {
      query: ALL_CUSTOMER_ORDERS_SHORTENED,
      variables(){
        return {
          page: 0,
          perPage: this.perPage,
          searchKeyword: this.searchKeyword,
          orderPayment: this.paymentStatus,
          orderStatus: ["601fdbd6-c437-4758-98a2-e807e847f566", "b3180af8-62c8-44ce-8432-64c02c5e5a56", "37bd4482-06ed-409d-845e-bdc6334c5505", "e6c0554c-aed8-4c39-b431-cbc239c0fa40" ], //delivered, loaded, not loaded, open
          orderCustomers: this.branchIds
        }
      }
    }
  },
  watch: {
    institution(){
      this.getCustomerBranches()
    }
  },
  computed: {
    ... mapGetters({
      httpLoading: 'http/httpLoading',
      httpErrors: 'http/httpErrors'
    })
  },
  mounted() {
    this.currentPage = parseInt(this.$route.query.page) || 1
  },
  methods: {
    ... mapActions({
      generateManualOrderStatement: 'http/generateManualOrderStatement',
    }),
    viewOrderInvoice(public_id){
      this.$router.push(routeItems.customer_order_invoice_route+'/'+public_id)
    },
    getCustomerBranches(){
      const branchIds = []
      this.institution.branches.forEach((branch) =>{
        branchIds.push(branch.publicId)
      })
      this.branchIds = branchIds
    },
    selectFn(rows){
      const orderIds = []
      rows.forEach((row) => {
        orderIds.push(row.publicId)
      })
      this.selectedOrders = orderIds
    },
    async generateStatement(institutionName){
      const response = await this.generateManualOrderStatement({"order_ids": this.selectedOrders})
      if(response.data.type === "application/pdf"){
        downloadFileConfig(response, `${institutionName} Order Statements.pdf`)
        await this.$apollo.queries.orders.refetch()
      }else {
        errorToast('Error generating statements')
      }
    }
  }
}
</script>

<style scoped>

</style>
